// extracted by mini-css-extract-plugin
export default {"mixed":"columns_mixed__yiuLD"};